import React from 'react';

import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';
import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import { WidgetFrame } from 'components/common/WidgetWithCards/WidgetCard/WidgetFrame/WidgetFrame';
import classes from 'components/common/WidgetWithCards/WidgetCard/widgetCard.module.scss';

import { Radio } from 'components/DesignSystem/Radio';

enum ToggleBy {
    FluxIndex = 'Flux index',
    CriticalityScore = 'Criticality Score',
}

interface ScoreCardProps {
    titleColor?: string;
    titleText: string;
    scoreValue?: string;
    contentHeight?: string;
    showToggleRadioInput?: boolean;
    selectToggle?: (event) => void;
    tooltipContent?: string | number;
    id?: string;
    toggle?: ToggleBy;
    children: React.ReactNode;
}

export const WidgetCard = ({
    children,
    titleColor = 'white',
    titleText,
    scoreValue,
    contentHeight = '100%',
    showToggleRadioInput = false,
    selectToggle,
    toggle,
    tooltipContent,
    id,
}: ScoreCardProps) => {
    const controlProps = (item) => ({
        checked: toggle === item,
        onChange: selectToggle,
        value: item,
        name: 'toggle-change-by',
    });

    return (
        <WidgetFrame
            id={id}
            className={classes.widgetCardWrapper}
            title={titleText}
            titleComponents={[
                <span style={{ color: titleColor }} key={'span-color'}>
                    {tooltipContent ? (
                        <CustomizedTooltip
                            tooltipPosition={TooltipPosition.Top}
                            triggerElement={
                                <span className={classes.scoreValue} id={`${id}_scoreValue`}>
                                    {scoreValue}
                                </span>
                            }
                            tooltipContent={tooltipContent}
                        />
                    ) : (
                        <span className={classes.scoreValue} id={`${id}_scoreValue`}>
                            {scoreValue}
                        </span>
                    )}
                    <div className={classes.progressSelection}>
                        {showToggleRadioInput && (
                            <>
                                <span>By</span>

                                <Radio {...controlProps(ToggleBy.FluxIndex)} label={ToggleBy.FluxIndex} />

                                <Radio {...controlProps(ToggleBy.CriticalityScore)} label={ToggleBy.CriticalityScore} />
                            </>
                        )}
                    </div>
                </span>,
            ]}
        >
            <div style={{ height: contentHeight }} className={classes.cardContent}>
                {children}
            </div>
        </WidgetFrame>
    );
};
